exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nform input, form button {\n    display: inline-block;\n}\n\n", ""]);

// exports
